import * as React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";

import { cn } from "@bcc/lib/utils";
import { setLabelTestId } from "./label.utils";

function Label({
  className,
  testId,
  htmlFor,
  children,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root> & {
  testId?: string;
}) {
  // Generate default testId: testId prop > htmlFor > children text > 'unnamed'
  const finalTestId =
    testId ??
    setLabelTestId(
      htmlFor ?? (typeof children === "string" ? children : "unnamed"),
    );

  return (
    <LabelPrimitive.Root
      data-slot="label"
      data-testid={finalTestId}
      htmlFor={htmlFor}
      className={cn(
        "flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
        className,
      )}
      {...props}
    >
      {children}
    </LabelPrimitive.Root>
  );
}

export { Label };
